import { Plugin } from 'ckeditor5';

export default class SpanTag extends Plugin {
	init() {
		const editor = this.editor;
		this._defineSchema( editor );
		this._defineConverters( editor );
		this.handleEnterKeyPress();
	}

	createElement( editor, element ) {
		const fontSize = element.getChild( 0 ).getAttribute( 'fontSize' );
		editor.model.change( ( writer ) => {
			const newElement = writer.createElement( element.name );
			writer.insertText( ' ', { invert: true, fontSize }, newElement );
			if (editor.model.document.selection.focus.isAtEnd) {
				writer.insert( newElement, element, 'after' );
				writer.setSelection( newElement, 0 );
			} else if ( editor.model.document.selection.focus.isAtStart ) {
				writer.insert( newElement, element, 'before' );
				writer.setSelection( newElement, 0 );
			} else {
				const positionOfSplit = writer.split( editor.model.document.selection.getFirstPosition() );
				/* original code, maybe we need it again
				writer.setSelection( writer.createPositionBefore( positionOfSplit.position.nodeAfter ) );
				*/

				/* new code */
				writer.setSelection(positionOfSplit.position.nodeAfter, 0 );
			}
		});
	}

	handleEnterKeyPress() {
		const editor = this.editor;

		editor.editing.view.document.on( 'enter', ( evt, data ) => {
			if ( editor.model.document.selection.getFirstPosition().parent.name != 'listItem' ) {
				data.preventDefault();
				evt.stop();
				if ( editor.model.document.selection !== null ) {
					const elementToCreate =
						editor.model.document.selection.getFirstPosition().parent;
					this.createElement( editor, elementToCreate );
				}
			}
		});
	}

	_defineSchema( editor ) {
		editor.model.schema.extend( '$text', {
			allowAttributes: 'invert',
		} );
	}

	_defineConverters( editor ) {
		editor.conversion.for( 'downcast' ).attributeToElement({
			model: 'invert',
			view: ( attributeValue, { writer } ) => {
				const spanTag = writer.createAttributeElement(
					'span',
					{},
					{ priority: 7 }
				);
				return spanTag;
			},
		} );
		editor.conversion.for( 'upcast' ).attributeToAttribute( {
			view: {
				name: 'span',
				key: 'class',
			},
			model: 'invert',
		} );
	}
}
